import { SerializableObject } from '../../common-react/core';

import { AddressChange } from './address-change.do';
import { FamilyMember } from './family-member.do';

export class FamilyMembersNewAddress extends SerializableObject {
  /**
   * TODO: TP-9533 This object needs to match object from the backend.
   * @see mobiz-backend:UserProfileController.ChangeAddressOfFamilyMembers()
   * @deprecated The FamilyMembersNewAddress needs to match structure from the backend.
   */
  public addressChange: AddressChange;
  public familyMembersToChangeAddressFor: FamilyMember[];
}
